import { Route, NavigationGuardNext } from 'vue-router';
import Vue from 'vue';
import { Guard } from '@glittr/frontend-core/src/plugins/guards/guardWrapper';

export default {
  name: 'ShareGuard',
  async routeBeforeEnter(to: Route, from: Route) {
    await Vue.$guards.waitForAppLoad();
    const shareId = to.query.shareId ?? to.params.shareId;
    const loggedInShareId = Vue.$auth.getClaim('appShareId');
    if (shareId && shareId !== loggedInShareId) {
      // Fixes #16573 Aufruf des Montagedokument-Sharings führt zu PSOD (403 Unauthorized).
      // There exists a race condition when the login happens while a refresh is undergoing.
      // This could lead to the access token of the login be replaced with the one of the refresh.
      // This effectively undoes the login and the old shareId remains authenticated, later causing a 403 error.
      // Fix: Vue.$auth.refresh() awaits the currently running refresh (or performs a new refresh)
      await Vue.$auth.refresh();
      // Now, no refresh should be running, so login can be called
      await Vue.$auth.login({ shareId });
    }
  },
} as Guard;
